import React from 'react'
import { BadgeSkeleton } from 'src/component/ui/badge/badge-skeleton'
import { Skeleton } from 'src/component/ui/skeleton'
import { SUGGESTED_SERIES_ASPECT_CLASS } from 'src/constants/suggested-series'
import { cn } from 'src/lib/utils'

interface SuggestedSeriesSkeletonProps {
  className?: string
}

/** Loading placeholder aligned with {@link SuggestedSeriesCard} (full width, aspect, header + body blocks). */
export const SuggestedSeriesSkeleton = ({ className }: SuggestedSeriesSkeletonProps): React.ReactElement => {
  return (
    <div
      className={cn(`relative ${SUGGESTED_SERIES_ASPECT_CLASS} w-full overflow-hidden rounded-md shadow-lg`, className)}
      data-testid="suggested-series-skeleton"
    >
      <Skeleton className="h-full w-full rounded-none bg-tertiary-grey" />
      <div className="absolute inset-0 flex flex-col justify-between p-6">
        <div className="flex shrink-0 items-start justify-between gap-2">
          <Skeleton className="h-10 w-36 rounded-md bg-primary-gray md:h-12 md:w-40" />
          <Skeleton className="h-6 w-6 shrink-0 rounded-full bg-primary-gray" />
        </div>
        <div className="w-full">
          <div className="max-w-md">
            <Skeleton className="mb-1 h-5 w-32 bg-primary-gray" />
            <Skeleton className="mb-3 h-10 w-full max-w-[14rem] bg-primary-gray" />
            <div className="mb-3 flex gap-3">
              <BadgeSkeleton />
              <BadgeSkeleton />
            </div>
          </div>
          <Skeleton className="mb-2 h-4 w-40 bg-primary-gray" />
          <Skeleton className="h-1.5 w-full rounded-full bg-primary-gray" />
        </div>
      </div>
    </div>
  )
}
